import axiosClient from '../configs/axios';

class UploadFile {
  async uploadFile(data) {
    try {
      const response = await axiosClient.post('/upload/uploads', data);
      return response.data;
    } catch (error) {
      console.error('Axios upload error:', error.response?.data || error.message);
      throw error;
    }
  }
}

export default new UploadFile();